<div class="manage-be-page">
  <div class="page-wrapper">
    <button
      [routerLink]="['/business-list']"
      class="btn btn-ghost btn-default btn-sm back"
    >
      <i class="fas fa-chevron-left"></i>
      <span i18n="@@Back">Back</span>
    </button>
    <ng-container *ngIf="accessDenied">
      <h2 i18n="@@Access denied">Access denied</h2>
    </ng-container>
    <ng-container *ngIf="!accessDenied">
      <h2
        class="editable-page-title"
        [ngClass]="{ editing: businessEntity.nameEdition }"
      >
        <ng-container *ngIf="!businessEntity.nameEdition">{{
          businessEntity.name
        }}</ng-container>
        <i
          class="far fa-pencil"
          (click)="businessEntity.nameEdition = !businessEntity.nameEdition"
          *ngIf="!businessEntity.nameEdition"
        ></i>
        <input
          *ngIf="businessEntity.nameEdition"
          type="text"
          class="form-control"
          [(ngModel)]="businessEntity.name"
        />
        <button
          i18n="@@Save"
          *ngIf="businessEntity.nameEdition"
          (click)="confirmNameChangeModal(confirmNameChangeModalTemplate)"
          class="btn btn-primary btn-xs btn-green"
        >
          Save
        </button>
        <button
          i18n="@@Cancel"
          *ngIf="businessEntity.nameEdition"
          (click)="businessEntity.nameEdition = !businessEntity.nameEdition"
          class="btn btn-secondary btn-xs"
        >
          Cancel
        </button>
      </h2>
      <div class="manage-be-permissions">
        <div
          i18n="@@Manage users"
          class="system-message info fill rounded-corners"
        >
          Manage users
        </div>
      </div>
      <div class="list-table manage-be">
        <div class="heading-container">
          <div i18n="@@Name" class="list-column user">Name</div>
          <div i18n="@@Has root" class="list-column root">Has root</div>
          <div i18n="@@Has create" class="list-column create">Has create</div>
          <div i18n="@@Has write" class="list-column write">Has write</div>
          <div i18n="@@Has read" class="list-column read">Has read</div>
          <div class="list-column actions-column"></div>
        </div>
        <div class="list-container">
          <div class="list-item" *ngFor="let user of businessEntity.users">
            <div class="list-column user">
              {{ user.fullName }}
              <span>{{ user.email }}</span>
            </div>
            <div class="list-column root remove-inner-top-space">
              <div class="form-check form-switch green">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="user.has_root"
                  (ngModelChange)="onAccessChange(user)"
                />
              </div>
            </div>
            <div class="list-column create remove-inner-top-space">
              <div class="form-check form-switch green">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [disabled]="user.has_root"
                  [(ngModel)]="user.has_create"
                  (ngModelChange)="onAccessChange(user)"
                />
              </div>
            </div>
            <div class="list-column write remove-inner-top-space">
              <div class="form-check form-switch green">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [disabled]="user.has_create"
                  [(ngModel)]="user.has_write"
                  (ngModelChange)="onAccessChange(user)"
                />
              </div>
            </div>
            <div class="list-column read remove-inner-top-space">
              <div class="form-check form-switch green">
                <input
                  class="form-check-input"
                  type="checkbox"
                  disabled
                  [(ngModel)]="user.has_write"
                  (ngModelChange)="onAccessChange(user)"
                />
              </div>
            </div>
            <div class="list-column actions-column">
              <a
                *ngIf="!user.has_root || nbRoots > 1"
                class="trash"
                (click)="removeUser(user)"
              >
                <i class="fal fa-trash-alt"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="manage-be-user-add">
          <div class="input-group" [ngClass]="{ invalid: emailFieldInvalid }">
            <input
              type="email"
              class="form-control"
              [(ngModel)]="emailToAdd"
              (focus)="clearEmailFieldValidation()"
              i18n-placeholder="@@Email"
              placeholder="Email"
            />
            <i
              class="fas fa-info-circle validation-tooltip"
              *ngIf="emailFieldInvalid"
              i18n-tooltip="@@Email validation"
              tooltip="Email validation"
            ></i>
            <button
              i18n="@@Add users"
              class="btn btn-primary"
              (click)="addUser()"
              type="button"
            >
              Add users
            </button>
          </div>
          <div
            i18n="@@Email validation failed"
            class="validation-message"
            *ngIf="emailFieldInvalid"
          >
            Email validation failed
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #confirmNameChangeModalTemplate>
  <div class="modal-header">
    <h4 i18n="@@Confirmation" class="modal-title pull-left">Confirmation</h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="bsModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p
      i18n="
        @@This modification is considered <span
        class=&quot;strong&quot;>critical</span>. Please confirm the following
        change:"
      class="confirmation-modal-text"
    >
      This modification is considered <span class="strong">critical</span>.
      Please confirm the following change:
    </p>
    <div class="confirmation-modal-change-detail-container">
      <div class="orig-name">
        <h5 i18n="@@Original name" class="upper-text">Original name</h5>
        <span class="strong">{{ businessEntity.originalName }}</span>
      </div>
      <div>
        <h5 i18n="@@New name" class="upper-text">New name</h5>
        <span class="strong">{{ businessEntity.name }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      i18n="@@Confirm"
      type="button"
      class="btn btn-primary btn-red"
      (click)="confirmNameChange(); bsModalRef?.hide()"
    >
      Confirm
    </button>
    <button
      i18n="@@Cancel"
      type="button"
      class="btn btn-secondary"
      (click)="bsModalRef?.hide()"
    >
      Cancel
    </button>
  </div>
</ng-template>
